
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
XButton,
Flexbox,
FlexboxItem,
XTextarea,
Group
},
data(){
return {
style0:'default',
style1:'default',
style2:'primary',
style3:'default'
}
},
methods:{
changeStyle(index){
for(let i = 0 ; i < 4 ; i ++){
this['style' + i] = 'default';
}
this['style' + index] = 'primary';
}
}
}



// WEBPACK FOOTER //
// ./src/components/suggest.vue